module.exports = __webpack_public_path__ + "media/images/icons/outlined/bg-colors-2b4d417c0a1fa43f81e543e0d363d701.svg";